import { msg } from "@lingui/core/macro";
import { useLingui } from "@lingui/react";

import { useAssetLookup } from "../api/useAssetLookup";
import { formatGameTime } from "../format/formatGameTime";
import type { FixOf } from "../model/Fix";
import { AssetList } from "./AssetList";

const LABEL = msg({
  id: "analysis.fix.core_build_order",
  message: "Core items in order:",
});
const STEP = msg({
  id: "analysis.fix.core_build_order.step",
  message: "by {baseline} (you: {bought})",
});
const NOT_BOUGHT = msg({ id: "analysis.fix.core_build_order.not_bought", message: "not bought" });

// Ключевые предметы в порядке сильных игроков на герое и когда их купил игрок.
export const CoreBuildOrderFix = ({ fix }: { fix: FixOf<"core_build_order"> }) => {
  const { i18n } = useLingui();
  const findItem = useAssetLookup("items");
  return (
    <AssetList
      label={i18n._(LABEL)}
      entries={fix.params.steps.map((step) => ({
        asset: findItem(step.item_id),
        caption: i18n._({
          ...STEP,
          values: {
            baseline: formatGameTime(step.baseline_at_s),
            bought:
              step.bought_at_s === null ? i18n._(NOT_BOUGHT) : formatGameTime(step.bought_at_s),
          },
        }),
      }))}
    />
  );
};
